/**
 * <scroll-loop> — faixa que rola sem parar (texto rolante, depoimentos Glow). ÚNICA do tema.
 *
 * Markup (a seção escreve UM grupo; o componente copia quantos precisar para cobrir a largura):
 *   <scroll-loop class="scroll-loop" data-speed="5" [data-reverse]>
 *     <div class="scroll-loop__group">…itens…</div>
 *   </scroll-loop>
 *
 * - data-speed: 1 (lento) a 10 (rápido) → 20 a 200 px por segundo; a velocidade é a mesma em qualquer tela.
 * - Cópias entram com aria-hidden e inert (leitor de tela e teclado veem só o original).
 * - Cada grupo anda o próprio tamanho (translateX -100%), então a emenda não aparece.
 * - Para com o mouse em cima; movimento reduzido: fica parado (CSS).
 *
 * Carregado pelas seções que usam. Depende de base.js (EssenceBaseComponent).
 */
(function () {
  "use strict";

  if (customElements.get("scroll-loop") || !window.EssenceBaseComponent) return;

  class ScrollLoop extends window.EssenceBaseComponent {
    init() {
      this.group = this.querySelector(":scope > .scroll-loop__group");
      if (!this.group) return;
      this.__resize = new ResizeObserver(this.__fill.bind(this));
      this.__resize.observe(this);
    }

    __fill() {
      var groupWidth = this.group.getBoundingClientRect().width;
      if (!groupWidth) return;

      // grupos suficientes para cobrir a faixa inteira mais um (o que está saindo)
      var needed = Math.ceil(this.clientWidth / groupWidth) + 1;
      var groups = this.querySelectorAll(":scope > .scroll-loop__group");
      for (var i = groups.length; i < needed; i++) {
        var copy = this.group.cloneNode(true);
        copy.setAttribute("aria-hidden", "true");
        copy.inert = true;
        copy.querySelectorAll("[id]").forEach(function (el) { el.removeAttribute("id"); });
        copy.querySelectorAll("[data-shopify-editor-block]").forEach(function (el) { el.removeAttribute("data-shopify-editor-block"); });
        this.appendChild(copy);
      }

      var level = Math.min(10, Math.max(1, parseInt(this.dataset.speed, 10) || 5));
      var pixelsPerSecond = level * 20;
      this.style.setProperty("--scroll-loop-duration", (groupWidth / pixelsPerSecond).toFixed(2) + "s");
      this.setAttribute("data-ready", "");
    }

    destroy() {
      if (this.__resize) this.__resize.disconnect();
    }
  }

  customElements.define("scroll-loop", ScrollLoop);
})();
